import React from "react";
import { Component } from "react";
import { notify } from "react-notify-toast";
// import Tabs from "../../Components/Tabs/Tabs.js";
import CollegeContainer from "../Container/CollegeContainer";
import { connect } from "react-redux";
import Personnel2 from "../College/PersonnelForm";
import { API } from "../../API";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AddCircleIcon from '@material-ui/icons/AddCircle';

// Disable outline for focused item
import "./app.css"
import { permIndices } from "../../Permissions"

import { updatePersonnel, createPersonnel, deletePersonnel } from "../../redux/college/college.actions"
import uuid from "uuid/v4";

const isNumeric = (value) => {
  return /^[0-9]*$/.test(value);
};

export class Personnel extends Component {
  constructor(props) {
    super(props);

    if (this.props.user === null) {
      window.location = "/login";
    }

    this.persRef = React.createRef();

    // const { personnel } = this.props;
    // // console.log('pers', personnel)
    // var tabPairs = []
    // for (var i = 0; i < personnel.length; i++) {
    //   const tabPair = {
    //     tabKey: personnel[i]._id,
    //     rn: ('reference_name' in personnel[i]) ? personnel[i].reference_name : 'default_ref',
    //   }
    //   tabPairs.push(tabPair)
    // }

    this.state = {
      // personnel_first_name: this.props.college.personnel_first_name,
      // personnel_last_name: this.props.college.personnel_last_name,
      // role_title: this.props.college.role_title,
      // manager_email: this.props.college.manager_email,
      // phoneNo: this.managers.phoneNo,
      // phoneNo_verified: this.props.college.phoneNo_verified,
      isMobileValid: false,
      tabPairs: [],
      // personnels: [],
      isShowing: false,
      current_index: 0,
      // campuses: [],
      inst_id: '',
      width: 0,
      tabindex: 0,
      initialChange: false,
      // customer: '',
    };
  }

  setTabPairs = () => {
    const { personnel } = this.props;
    // console.log('pers', personnel)
    // console.log("setTabPairs: ", personnel)
    var tabPairs = []
    for (let per of personnel) {
      const tabPair = {
        tabKey: per._id || per.temp_id,
        rn: per.reference_name || 'default_ref',
      }
      tabPairs.push(tabPair)
    }
    // console.log("tabPairs: ", tabPairs)
    this.setState({
      tabPairs: tabPairs,
    })
  }

  clickTab = (key) => {
    if (key == "addNew") {
      //console.log('add newinst id', this.props.user.institution_id)
      // API.createPersonnel({
      //   inst_id: this.props.user.institution_id,
      // }).then((res) => {
      //   this.props.createPersonnel(res.data)
      //   this.clickTab(0)
      // })
      this.addNewPersonnel()
    } else {
      // console.log("keyyy: ", key, this.props.personnel, this.state.current_index)
      if (key === 0) {
        this.setState({
          current_index: key,
        }, () => {
          console.log('swaped')
          // this.persRef.current.swapTab(this.props.personnel[key]._id, this.props.personnel, key);
          this.persRef.current.swapTab(this.props.personnel, key);
        })
      } else {
        for (var i = 0; i < this.props.personnel.length; i++) {
          if (this.props.personnel[i]._id == key || this.props.personnel[i].temp_id == key) {
            this.setState({
              current_index: i,
            }, () => {
              // this.persRef.current.swapTab(key, this.props.personnel, this.state.current_index);
              this.persRef.current.swapTab(this.props.personnel, this.state.current_index);
            })
          }
        }
      }
    }

  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  componentDidMount = () => {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.setTabPairs();
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  handleChangeIndex = (index) => {
    this.setState({
      tabindex: index,
    }, () => {
      if (this.state.initialChange) {
        console.log('not ini')
      } else {
        this.setState({
          tabindex: 0,
          initialChange: true,
        })
        console.log('ini')
      }
    });
  }

  handleChange = (event, value) => {
    this.setState({
      tabindex: value,
    });
  };

  tabs = [
    {
      text: this.props.user?.is_childcare_centre ? "Centre" : "Campus",
      pathname: "/Campus",
    },
    {
      text: "Personnel",
      pathname: "/Personnel",
      active: true,
    },
    {
      text: this.props.user?.is_childcare_centre ? "Shifts" : "Timetable",
      pathname: "/TimeTable",
    },
    {
      text: "Finance Settings",
      pathname: "/FinanceSetting",
    },
    {
      text: "Budget Settings",
      pathname: "/BudgetSetting",
    },
  ];

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleRadioChange = (e) => {
    let departments = []; /* this line should delete after this.state can work */
    this.setState({ departments: departments.concat(e.target.title) });
  };

  handleChangeNumber = () => {
    this.setState({
      showConfirmNumber: false,
      isMobileValid: false,
    });
    this.props.handleStateChange("contact_number_verified", false);
  };

  handleConfirmNumber = () => {
    const mobile = this.props.state.phoneNo;
    if (mobile.length === 10) {
      if (isNumeric(mobile)) {
        this.setState({
          showConfirmNumber: true,
          isMobileValid: false,
        });
      } else {
        notify.show("Please enter numbers only");
      }
    } else {
      notify.show("Please enter 10 digits");
    }
  };

  // the permission will send to the backend a number
  handlePermissions = (e) => {
    let permissions = 0;
    this.setState({ permissions: permissions + e.target.value });
  };

  handleConfirmNumber = () => {
    let errors = false;
    const mobile = this.props.state.phoneNo;
    if (mobile.length === 10) {
      if (isNumeric(mobile)) {
        this.setState({
          showConfirmNumber: true,
          isMobileValid: false,
        });
        if (!this.state.phoneNo_verified) {
          notify.show("Please verify your phone number");
          errors = true;
        }
        if (this.state.departments_delivered.length === 0) {
          notify.show("Please add at least one delivered department");
          errors = true;
        }
        if (this.state.permissions === 0) {
          notify.show("Please add at least one permission");
          errors = true;
        }
      }
    } else {
      notify.show("Please enter 10 digits");
    }
  };

  handlePermissions = (e) => { };

  handleSubmit = (personnel, permissions) => {
    // personnel.permissions = permissions
    personnel.access_permission = permissions

    // create new personnel
    if (personnel?.is_new_personnel) {
      // should create a personnel first
      API.createPersonnel({
        inst_id: this.props.user.institution_id,
      }).then((res) => {
        personnel._id = res?.data?._id
        const isNewPersonnel = personnel.is_new_personnel
        delete personnel.is_new_personnel
        this.updatePersonnelData(personnel, isNewPersonnel)
      }).catch(err => notify.show(err?.response?.data?.message))
    } else {
      // update personnel
      this.updatePersonnelData(personnel, false)
    }
  };

  updatePersonnelData = (personnel, isNewPersonnel) => {
    const payload = {
      personnel: personnel,
      is_new_personnel: isNewPersonnel
    }

    API.updatePersonnel(payload).then((res) => {
      this.props.updatePersonnel(personnel)
      window.location.reload(false)
      API.instProgressEmail({
        inst_id: this.props.user.institution_id,
        email_address: this.props.user.email,
        etype: "PSN_CONF",
      })
    }).catch((err)=>{
      if(err?.response?.data?.errors?._id == "Existing Email"){
        notify.show("This email address is already in use. Please use a different email.")
      }
      else if(err?.response?.data?.message) {
        notify.show(err?.response?.data?.message)
      } else {
        notify.show("Failed to update Personnel")
      }
    })
  }

  handleDelete = (personnel) => {
    console.log('in js delete', personnel)
    API.deletePersonnel({
      _id: personnel._id,
    }).then((res) => {
      console.log('delete result', res.data)
      this.props.deletePersonnel(personnel)

      window.location.reload()
    })
  };

  addNewPersonnel = () => {
    const personnelData = {
      _id: null,
      temp_id: uuid(),
      personnel_first_name: '',
      personnel_last_name: '',
      personnel_role: '',
      personnel_email: '',
      personnel_mobile: '',
      campuses: [],
      personnel_departments: [],
      access_permission: {
        manage_payment: false
      },
      get_booking_email: false,
      reference_name: '',
      institution: this.props.user.institution_id,
      is_new_personnel: true
    }
    this.props.createPersonnel(personnelData)
    this.setTabPairs()
    this.clickTab(0)
    // API.createPersonnel({
    //   inst_id: this.props.user.institution_id,
    // }).then((res) => {
    //   this.props.createPersonnel(res.data)

    //   this.clickTab(0)
    // })
  }

  handleTabChange = (value) => {
    console.log(value)
  }

  render() {
    var tabI = -1;

    const styles = {
      root: {
        '&.Mui-selected': {
          outline: 'none',
        },
      },
      tabs: {
        background: '#fff',
      },
      slide: {
        padding: 15,
        minHeight: 100,
      },
      slide1: {
        backgroundColor: '#FFFFFF',
      },
    };

    return (
      <div>
        {(this.state.width > 480) ? (
          <CollegeContainer
            header={this.props.user?.is_childcare_centre ? "Add Personnel" : "Add Manager"}
            user={this.props.user}
            tabs={this.tabs}
            tabPairs={this.state.tabPairs}
            onClickTab={this.clickTab}
            initialIndex={(localStorage.getItem('personnel-Index') != null) ? parseInt(localStorage.getItem('personnel-Index')) : 0}
            viewbookings={this.props.viewbookings}
            addable={this.props.editpersonnel}
            //buttons={buttons}
            //tabs={tabs}
            handleSubmit={this.handleSubmit}
          >
            {this.props.personnel.length == 0 ? (
              <div className="absolute-align-items-center">
                <p>Currently there is no data available. Click ADD NEW to create an entry.</p>
              </div>
            ) : (
              <Personnel2
                campuses={this.props.campuses}
                personnel={this.props.personnel}
                current_index={this.state.current_index}
                ref={this.persRef}
                state={this.state}
                handleRadioChange={this.handleRadioChange}
                handleFormFieldChange={this.handleFormFieldChange}
                handleSubmit={this.handleSubmit}
                handleDelete={this.handleDelete}
                editpersonnel={this.props.editpersonnel}
                user={this.props.user}
              />
            )}
          </CollegeContainer>
        ) : (
          <CollegeContainer
            header={this.props.user?.is_childcare_centre ? "Add Personnel" : "Add Manager"}
            tabs={this.tabs}
            tabPairs={this.state.tabPairs}
            onClickTab={this.clickTab}
            initialIndex={(localStorage.getItem('personnel-Index') != null) ? parseInt(localStorage.getItem('personnel-Index')) : 0}
            viewbookings={this.props.viewbookings}
            addable={this.props.editpersonnel}
          // buttons={buttons}
          // tabs={tabs}
          // handleSubmit={this.handleSubmit}
          >
            <Tabs value={this.state.tabindex}
              fullWidth
              style={styles.tabs}
              onChange={this.handleChange}
              variant="scrollable"
              TabIndicatorProps={{
                style: { background: "#34F1C8", color: "#34F1C8" }
              }}
              scrollButtons="on">
              {this.props.personnel.map((personnel) => (
                <Tab label={<span style={this.props.personnel[this.state.tabindex] == personnel ? ({ color: "#34F1C8" }) : ({ color: "gray" })}>{personnel.reference_name}</span>} />
              ))}
              {this.props.editpersonnel && <Tab label={<span style={{ color: "#3BB4D8" }}>AddNew</span>} icon={<AddCircleIcon style={{ color: "#3BB4D8" }} />} onClick={this.addNewPersonnel} />}
            </Tabs>
            <SwipeableViews index={this.state.tabindex} onChangeIndex={this.handleChangeIndex} enableMouseEvents>
              {this.props.personnel.map((personnel) => (
                <div style={Object.assign({}, styles.slide, styles.slide1)}>
                  <Personnel2
                    mobilePer={personnel}
                    campuses={this.props.campuses}
                    personnel={this.props.personnel}
                    current_index={this.state.current_index}
                    ref={this.persRef}
                    state={this.state}
                    handleRadioChange={this.handleRadioChange}
                    handleFormFieldChange={this.handleFormFieldChange}
                    handleSubmit={this.handleSubmit}
                    handleDelete={this.handleDelete}
                    editpersonnel={this.props.editpersonnel}
                    user={this.props.user}
                  />
                </div>
              ))}
            </SwipeableViews>
          </CollegeContainer>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  console.log('state', state)
  return {
    user: state.college.user,
    campuses: state.college.campuses,
    personnel: state.college.personnel,
    viewbookings: (state.college.user.permissions) ? state.college.user.permissions & (1 << permIndices.vi_book) : 1,
    editpersonnel: (state.college.user.permissions) ? state.college.user.permissions & (1 << permIndices.ed_per) : 1,
    transfer_ownner: !state.college.user.permission,
  };
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonnel: (personnel) => dispatch(updatePersonnel(personnel)),
  createPersonnel: (personnel) => dispatch(createPersonnel(personnel)),
  deletePersonnel: (personnel) => dispatch(deletePersonnel(personnel)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Personnel);
